import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import moment from "moment-timezone";

// Atölye saatleri kullanıcının bulunduğu ülkeden bağımsız olarak her zaman Türkiye saatiyle gösterilsin
moment.tz.setDefault("Europe/Istanbul");

// window.location.href = "https://sampiyona.tzv.org.tr";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
